import { Reveal } from "../components/Reveal";

export default function MemorySection() {
  return (
    <section className="max-w-[1400px] mx-auto px-6 md:px-10 py-24 md:py-36">
      <div className="grid md:grid-cols-12 gap-10">
        <Reveal className="md:col-span-5">
          <h2 className="font-display text-4xl md:text-6xl tracking-tighter font-medium leading-[0.98]">
            Your business shouldn't live in your head.
          </h2>
        </Reveal>
        <Reveal delay={0.1} className="md:col-span-6 md:col-start-7 self-end">
          <p className="text-lg md:text-xl text-neutral-500 leading-relaxed">
            Deals and deadlines, follow-ups and marketing, your calendar and inbox, all of it living in your memory instead of a system. Something always slips, and a dropped ball can cost the whole deal. Quexify is the AI-augmented right hand that runs it all in the background: transactions and closings, marketing and social, leads, calendar and admin. Nothing falls through, so you stay focused on growth.
          </p>
        </Reveal>
      </div>
    </section>
  );
}
